export const FPT_PROJECT_STATUS_OPTIONS = [
  "Bidding",
  "Active",
  "Lost",
  "Hold",
  "Archived",
  "Delivered",
  "Pipeline",
] as const;

export type FptProjectStatus = (typeof FPT_PROJECT_STATUS_OPTIONS)[number];

export const FPT_PROJECT_STATUS_ORDER: FptProjectStatus[] = [
  "Active",
  "Pipeline",
  "Bidding",
  "Hold",
  "Delivered",
  "Lost",
  "Archived",
];

export function normalizeProjectStatus(value?: string): FptProjectStatus {
  const normalized = String(value || "").trim().toLowerCase();
  switch (normalized) {
    case "active":
    case "in production":
      return "Active";
    case "pipeline":
      return "Pipeline";
    case "bidding":
    case "pitching":
      return "Bidding";
    case "hold":
    case "on hold":
      return "Hold";
    case "lost":
      return "Lost";
    case "archived":
      return "Archived";
    case "delivered":
      return "Delivered";
    default:
      return "Bidding";
  }
}

export function compareProjectStatuses(left?: string, right?: string) {
  const leftStatus = normalizeProjectStatus(left);
  const rightStatus = normalizeProjectStatus(right);
  const leftIndex = FPT_PROJECT_STATUS_ORDER.indexOf(leftStatus);
  const rightIndex = FPT_PROJECT_STATUS_ORDER.indexOf(rightStatus);
  if (leftIndex >= 0 && rightIndex >= 0) return leftIndex - rightIndex;
  if (leftIndex >= 0) return -1;
  if (rightIndex >= 0) return 1;
  return leftStatus.localeCompare(rightStatus);
}

export function getProjectStatusTone(status?: string) {
  switch (normalizeProjectStatus(status)) {
    case "Bidding":
      return "bg-[#e4a4a5] text-white border-[#e4a4a5]";
    case "Active":
      return "bg-[#234d6f] text-white border-[#234d6f]";
    case "Lost":
      return "bg-rose-50 text-rose-700 border-rose-200";
    case "Hold":
      return "bg-orange-50 text-orange-700 border-orange-200";
    case "Archived":
      return "bg-slate-100 text-slate-700 border-slate-200";
    case "Delivered":
      return "bg-[#597058] text-white border-[#597058]";
    case "Pipeline":
      return "bg-amber-50 text-amber-800 border-amber-200";
    default:
      return "border-slate-300";
  }
}

export function getProjectStatusColorHex(status?: string) {
  switch (normalizeProjectStatus(status)) {
    case "Bidding":
      return "#e4a4a5";
    case "Active":
      return "#234d6f";
    case "Lost":
      return "#ef4444";
    case "Hold":
      return "#f97316";
    case "Archived":
      return "#94a3b8";
    case "Delivered":
      return "#597058";
    case "Pipeline":
      return "#f59e0b";
    default:
      return "#cbd5e1";
  }
}
